module.exports = __webpack_public_path__ + "img/uz.a4884a96.svg";